import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import NomenclatureChange from "../../components/nomenclatureChange/NomenclatureChange";

const NomenclatureChangePage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <NomenclatureChange />
                </div>
            </div>
        </div>
    );
};

export default NomenclatureChangePage;
